<template>

    <FloatingPanel>

        <div class="shop::canvas-blocks-shop-overlappingCategories-LoopPanel">

            <SwitchInput
                label="Aantal kolommen"
                instruction="Kies hier het aantal kolommen per rij."
                :items="[
                    { value: 2 },
                    { value: 3 },
                ]"
                :options="options"
                :defaultValue="3"
                options-property="columnsCount"
                :open="true"
            />

        </div>

    </FloatingPanel>

</template>

<script>

import AbstractPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/AbstractPanel";
import FloatingPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/FloatingPanel";
import SwitchInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/SwitchInput";

export default {

    extends: AbstractPanel,

    components: {
        FloatingPanel,
        SwitchInput,
    },

}

</script>

<style lang="scss" scoped>

.shop\:\:canvas-blocks-shop-overlappingCategories-LoopPanel {

}

</style>
